import { useState } from 'react';
import { Stack, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSelector, useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { appSliceActions } from '../../appSlices/appSlice';
import SingleSelector from '../single-selector/singleSelector';

export default function RemoveVstDevice() {
  const { enqueueSnackbar } = useSnackbar();
  const { adaptorType } = window;
  const dispatch = useDispatch();
  const [vstHost, setVstHost] = useState(null);
  const hostList = useSelector((state) => state.app.hostList);

  const handleSubmit = () => {
    if (!vstHost) {
      enqueueSnackbar(`Error - VST device not selected`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    enqueueSnackbar(`Pending - remove VST host ${vstHost}`, {
      variant: 'info',
      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
    });
    dispatch(appSliceActions.removeVstHost(vstHost));
    enqueueSnackbar(`Success - removed VST host ${vstHost}`, {
      variant: 'success',
      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
    });
    setVstHost(null);
  };

  return (
    <>
      <Stack spacing={3} sx={{ mb: 2 }}>
        <SingleSelector
          id="remove-vst"
          placeholder="Type to search"
          label={`Select ${adaptorType} device`}
          value={vstHost}
          onChange={setVstHost}
          getOptionLabel={(option) => `${adaptorType} at ${option}`}
          options={hostList}
        />
      </Stack>
      <Box m={1} display="flex" justifyContent="flex-end" alignItems="flex-end">
        <LoadingButton size="large" type="submit" variant="contained" onClick={handleSubmit}>
          Remove
        </LoadingButton>
      </Box>
    </>
  );
}
